import { Avatar, ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useSelector } from "react-redux";
import React from "react";
import { IReduxState } from "../../store";
import MenuApp from "./MenuApp";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";


const Liste = () => {

  //Redux
  const { filteredActualites } = useSelector((state: IReduxState) => state.siteWeb);


  return (
    <>
      <div
        style={{
          padding: 10,
          height: "55vh",
          overflow: "auto",
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {filteredActualites.map((item, i: number) => {
              return (
                <div key={i}>
                  <ListItem
                    secondaryAction={
                      <MenuApp
                        item={item}
                      />
                    }
                  >
                    <ListItem>
                      <ListItemIcon>
                        <Avatar alt="Pas d'image" src={`${SITEWEB_SERVER_BASE_URL}/actualitesImages/${item?.actualiteImage}`} />
                      </ListItemIcon>
                      <ListItemButton>
                        <ListItemText
                          primary={item.titre}
                          secondary={
                            <Box style={{ display: "flex", flexDirection: "column" }}>
                              <Typography variant="caption">
                                {`Sous titre: ${item.sousTitre}`}
                              </Typography>
                              <Typography variant="caption">
                                {`Date: ${item.dateActualite}`}
                              </Typography>
                              <Typography variant="caption">
                                {
                                  `${item.active === 0 ? "Activée" : "désactivée"}`
                                }
                              </Typography>
                              <Typography variant="caption">
                                {
                                  `A la une: ${item.aLaUne === 0 ? "Non" : "Oui"}`
                                }
                              </Typography>
                            </Box>
                          }
                        />
                      </ListItemButton>
                    </ListItem>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </Box>
      </div>
    </>
  );
};
export default Liste;
